import React, { useState, useEffect } from 'react';
import { getSessionsForUser } from '../utils/quizSessionManager';
import { FileText, LogOut } from 'lucide-react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './MySessions.css';

const MySessions = ({ user, onSelectSession }) => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user?.email) {
      loadSessions();
    } else {
      setLoading(false);
    }
  }, [user?.email]);

  const loadSessions = async () => {
    setLoading(true);
    setError('');
    try {
      const list = await getSessionsForUser(user?.email);
      setSessions(list);
    } catch (err) {
      console.error('Failed to load sessions:', err);
      setError('Failed to load your quiz sessions');
    } finally {
      setLoading(false);
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error('Sign out error:', err);
    }
  };

  if (!user) return null;

  return (
    <div className="my-sessions-container">
      <div className="my-sessions-header">
        <h1>My Quiz Sessions</h1>
        <p>Quizzes assigned to you. Click to start.</p>
        <div className="my-sessions-user-row">
          <span className="user-email">{user.email}</span>
          <button type="button" className="btn-sign-out" onClick={handleSignOut}>
            <LogOut size={16} />
            Sign out
          </button>
        </div>
      </div>

      {loading ? (
        <div className="my-sessions-loading">
          <div className="loading-spinner"></div>
          <p>Loading your sessions...</p>
        </div>
      ) : error ? (
        <div className="my-sessions-error">{error}</div>
      ) : sessions.length === 0 ? (
        <div className="my-sessions-empty">
          <FileText size={48} className="empty-icon" />
          <h3>No quiz sessions yet</h3>
          <p>Your admin will assign quizzes to you. Check back later.</p>
        </div>
      ) : (
        <div className="my-sessions-list">
          {sessions.map((session) => (
            <button
              key={session.id}
              type="button"
              className="session-card"
              onClick={() => onSelectSession(session)}
            >
              <FileText size={24} className="session-icon" />
              <div className="session-info">
                <h3>{session.title || session.quizFileName || 'Quiz'}</h3>
                <p>
                  {session.assignedUserEmails?.length || 0} participant(s) · Created{' '}
                  {session.createdAt?.toDate?.()
                    ? session.createdAt.toDate().toLocaleDateString()
                    : 'recently'}
                </p>
              </div>
              <span className="session-arrow">→</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default MySessions;
